<script lang="ts">
	import { BaseViewModelContainer } from '@shared/svelte';
	import { BaseLayout } from '@shared/svelte-kit';
	import { getAppViewModel } from './app-view-model';
	import AppBar from './bar/AppBar.svelte';
	import HeadTagsView from './metadata/HeadTagsView.svelte';
	import { browser } from '$app/environment';
	import type { DeviceData } from '@shared/types';
	import type { UserSessionData } from '@localekey/types';
	import type { RouteName } from '$router';

	export let userSession: UserSessionData | undefined;
	export let device: DeviceData | undefined;
	export let currentRoutePath: RouteName | undefined;

	const viewModel = getAppViewModel({
		currentRoutePath,
		device,
		userSession,
	});

	const { showAppBar } = viewModel;
</script>

<svelte:window
	on:beforeunload={(event) => viewModel.handleAppClose(event)}
	on:popstate={(event) => viewModel.handlePopStateEvent(event)} />

<HeadTagsView />

<BaseLayout>
	<svelte:fragment slot="app-bar">
		{#if $showAppBar}
			<AppBar />
		{/if}
	</svelte:fragment>

	<BaseViewModelContainer
		viewModel={viewModel}
		id="app-container"
		class="max-w-container mx-auto flex flex-col p-3"
		fillHeight>
		<slot />
	</BaseViewModelContainer>
</BaseLayout>

{#if browser}
	{#await import('./dialogs/AppDialogsView.svelte') then Module}
		<Module.default />
	{/await}
{/if}
